import { ReactRouteObject } from "base/src/utils/routeUtil"

import { BaseRouter } from "base/src/infra/routes/baseRoutes"

import AprovarPedido from "../../views/aprovarPedido/aprovarPedido";
import PagarPedido from "../../views/pagarPedido/pagarPedido";
import NotaRepasse from "../../views/notaRepasse/notaRepasse";
import GerarLote from "../../views/gerarLote/gerarLote";

export const CampanhaRouter: ReactRouteObject[] = [
  ...BaseRouter,
  // {
  //   path: "/",
  //   element: <Campanha/>,
  // },
  {
    path: "/",
    element: <AprovarPedido />, //Default
  },
  {

    path: "aprovarPedido",
    element: <AprovarPedido />,
  },
  {
    path: "pagarPedido",
    element: <PagarPedido />,
    initialState: false
  },
  {
    path: "gerarLote",
    element: <GerarLote />,
    initialState: false
  },
  {
    path: "notaRepasse",
    element: <NotaRepasse />,
    initialState: false,
    ignoreSideBar: true,
    ignoreAuth: true,
    ignoreHeader: true
  },

  // {
  //   path: "premiacao",
  //   element: <Premiacao />, //Tela de pagamento antiga (ela fica no dominio)
  // },
];



export enum CampanhaParameters {
  // eslint-disable-next-line no-unused-vars
  campanhaId = "campanhaId"
}